// image sources for a shared file. browsers can't render .tif/.tiff, so for those we use
// what cases use: thumbnailUrl for previews and the deep zoom tiles (dziUrl) for the viewer.

const DZI_TILE_SIZE = 256;

const joinUrl = (base, path) => `${(base || "").replace(/\/$/, "")}/${(path || "").replace(/^\//, "")}`;

const withImageParams = (url, width) => `${url.replace(/ /g, "%20")}?auto=compress,format${width ? `&width=${width}` : ""}`;

export const isTiffPath = (path) => /\.tiff?$/i.test(path || "");

// path to the deep zoom descriptor without a leading slash, e.g. "dadidev/.../output.dzi"
const getDziPath = (row) => {
    const path = (row?.dziUrl || "").replace(/^\//, "");
    return path.includes("output.dzi") ? path : "";
};

// the deepest dzi level that still fits in one tile - its 0_0 tile is the whole image
const getDziPreviewTile = (row, imageCloudfront) => {
    const dziPath = getDziPath(row);
    const width = Number(row?.width);
    const height = Number(row?.height);
    if (!dziPath || !width || !height) return "";

    const maxLevel = Math.ceil(Math.log2(Math.max(width, height)));
    let level = maxLevel;
    while (level > 0 && Math.max(width, height) / Math.pow(2, maxLevel - level) > DZI_TILE_SIZE) level--;
    return joinUrl(imageCloudfront, `${dziPath}_files/${level}/0_0.jpeg`);
};

// preview urls in the order to try - <ShareThumb> falls through them on load errors
export const getPreviewCandidates = (row, imageCloudfront, width) => {
    if (!row || !imageCloudfront) return [];
    const sourceUrl = row.sourcepath ? withImageParams(joinUrl(imageCloudfront, row.sourcepath), width) : "";
    const thumbnailUrl = row.thumbnailUrl ? withImageParams(joinUrl(imageCloudfront, row.thumbnailUrl), width) : "";
    const dziTile = getDziPreviewTile(row, imageCloudfront);

    const candidates = isTiffPath(row.sourcepath)
        ? [thumbnailUrl, dziTile, sourceUrl]
        : [sourceUrl, thumbnailUrl, dziTile];
    return candidates.filter(Boolean);
};

// OpenSeadragon tile source - same logic as the deep zoom viewer in edit case / SharedDziView
export const getViewerTileSource = (row, imageCloudfront) => {
    if (!row || !imageCloudfront) return null;
    const dziPath = getDziPath(row);

    if (dziPath) {
        const width = Number(row.width);
        const height = Number(row.height);
        if (width && height) {
            return {
                Image: {
                    xmlns: "http://schemas.microsoft.com/deepzoom/2008",
                    Url: encodeURI(joinUrl(imageCloudfront, `${dziPath}_files/`)),
                    Format: "jpeg",
                    Overlap: 2,
                    TileSize: DZI_TILE_SIZE,
                    Size: { Width: width, Height: height },
                },
            };
        }
        // no dimensions on the record - let OpenSeadragon read them from the .dzi file
        return encodeURI(joinUrl(imageCloudfront, dziPath));
    }

    if (!row.sourcepath || isTiffPath(row.sourcepath)) return null;
    return {
        type: "image",
        url: encodeURI(joinUrl(imageCloudfront, row.sourcepath)),
        buildPyramid: false,
    };
};
